import { ITEM_TYPES } from '@/trendData/trendData.constants';
import { headlessRenderMode } from '@/hybrid/utilities/utilities';

export const Y_AXIS_MIN_TOTAL_WIDTH = 30;

export const GRAY_LANE_COLOR = '#f9f9f9';
export const WHITE_LANE_COLOR = '#ffffff';

export const CAPSULE_TYPES = [
  ITEM_TYPES.CAPSULE,
  ITEM_TYPES.UNCERTAIN_BOUNDED_CAPSULE,
  ITEM_TYPES.UNCERTAIN_UNBOUNDED_CAPSULE,
];

export interface ChartRegion {
  xMin: number;
  xMax: number;
  yMin: number;
  yMax: number;
  id?: string;
  dateTime?: string;
}

export const EMPTY_CHART_REGION = {
  xMin: null,
  xMax: null,
  yMin: null,
  yMax: null,
};

export interface XYPixelRegion {
  xMinPixel: number;
  xMaxPixel: number;
  yMinPixel: number;
  yMaxPixel: number;
  id: string;
  dateTime: string;
}

/**
 * Contains the extra fields that we use to extend any SeriesOptions object from Highcharts
 */
export interface SeeqSeriesOptions {
  xNumberFormat: string;
  yNumberFormat: string;
  xSignalName: string;
  ySignalName: string;
}

export type PixelTranslationFunction = (
  chart: Highcharts.Chart,
  minVal: number,
  maxVal: number,
) => { minPixel: number; maxPixel: number };

export type SeriesGroupedByAxis = {
  primarySeries: any;
  series: any[];
  hide?: boolean;
};

export const LINE_WIDTHS = {
  [ITEM_TYPES.SERIES]: headlessRenderMode() ? 2 : 1,
  [ITEM_TYPES.SCALAR]: headlessRenderMode() ? 2 : 1,
};

export const SHADOW_AGGREGATE = {
  width: 4,
  opacity: 1,
  offsetX: 0,
  offsetY: 0,
};

export const BAR_CHART_ESSENTIALS = {
  type: 'column',
  pointPlacement: 'on',
  minPointLength: 2,
};

export const ALPHA_DIMMED = 0.3;

export interface ChartLaneOptions {
  items: any[];
  lanes: number[];
  isCapsuleTime: boolean;
  chart: Highcharts.Chart;
  capsuleLaneHeight: number;
}

// Highcharts needs callbacks passed in to regenerate tick positions and other per axis settings at various points
// in the Highcarts lifecycle, so we can't rely on the initial chart or items passed in. Instead, pass in
// getters and provide the most up to date version of each.
export interface ChartGetters {
  getChart: () => Highcharts.Chart;
  getItems: () => any[];
}

export const ENABLED_MARKER = { enabled: true, radius: 2, symbol: 'circle' };
export const DISABLED_MARKER = { enabled: false, radius: 0 };
